<template>
  <div>
    <div class="new-order-wrapper">
      <h3 class="section-title-centered">{{ title }}</h3>
      <form @submit.prevent="onSubmit" class="form-order">
        <div class="form-row">
          <div class="col-6">
            <div class="form-group row" v-if="!isChangeOrder">
              <label class="col-sm-5 col-form-label" v-translate
                >Customer name</label
              >
              <div class="col-sm-7">
                <v-select
                  :class="{ 'no-show': !showDropdown }"
                  v-model="newBill.customer"
                  :filterable="false"
                  :options="filteredCustomers"
                  :ref="'customer'"
                  :placeholder="$gettext('Type to search')"
                  @search:focus="onFocus"
                  @search="onSearch"
                >
                  <template slot="no-options"> {{ noOptionText }} .. </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.label }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.label }}
                    </div>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="form-group row">
              <label 
                @click="showTableDialog()"
                class="col-sm-5 col-form-label" v-translate
                >Table<i class="icon-hand-pointer"></i
              ></label>
              <div class="col-sm-7">
                <div class="input-pad">
                  <input
                    name="table"
                    v-model="newBill.table"
                    type="text"
                    class="form-control"
                    autocomplete="off"
                  />
                  <span class="text-danger" v-if="errors.first('table')">{{
                    errors.first("table")
                  }}</span>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label 
                @click="showTableDialog()"
                class="col-sm-5 col-form-label" v-translate
                >Room<i class="icon-hand-pointer"></i
              ></label>
              <div class="col-sm-7">
                <div class="input-pad">
                  <input
                    name="room"
                    v-model="newBill.room"
                    type="text"
                    class="form-control"
                    autocomplete="off"
                    v-validate="newBill.table.length ? '' : 'required'"
                  />
                  <span class="text-danger" v-if="errors.first('room')">{{
                    errors.first("room")
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label class="col-sm-5 col-form-label" v-translate
                ># of Customers</label
              >
              <div class="col-sm-7">
                <input-pad
                  name="cover"
                  :item="newBill"
                  :property="'cover'"
                  :attributes="{ class: 'form-control' }"
                  :error="errors.first('cover')"
                  v-validate="'numeric'"
                />
              </div>
            </div>
            <div class="form-group row" v-if="!isChangeOrder">
              <label
                @click="showStaffDialog()"
                class="col-sm-5 col-form-label"
                v-translate
                >Staff ID<i class="icon-hand-pointer"></i
              ></label>
              <div class="col-sm-7">
                <div class="input-pad">
                  <input
                    name="staff"
                    v-model="newBill.staff"
                    type="text"
                    class="form-control"
                    autocomplete="off"
                    v-validate="newBill.staff ? '' : 'required'"
                  />
                  <span class="text-danger" v-if="errors.first('staff')">{{
                    errors.first("staff")
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-footer py-lg-3 text-center">
          <button
            id="new-order"
            type="submit"
            class="btn btn-primary px-5"
            v-translate
          >
            Ok
          </button>
        </div>
      </form>
    </div>
    <div v-if="dialog" id="StaffModal" class="modal">
      <grid-staff v-if="showGridStaff" @pickStaff="pickStaff" />
      <grid-table v-if="showGridTable" @pickTable="pickTable" @items="this.$store.state.auth.locations[this.user.location.id].locationTables" />
    </div>
  </div>
</template>

<script>
import BillService from "@/services/BillService";
import GridStaff from "@/components/GridStaff.vue";
import GridTable from "@/components/GridTable.vue";

export default {
  name: "FormOrder",
  props: ["title", "isChangeOrder", "tableSelected", "staffSelected", "step"],
  components: {
    GridStaff,
    GridTable,
  },
  data() {
    return {
      search: "",
      showDropdown: true,
      newBill: {
        room: "",
        table: "",
        staff: -1,
      },
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      showGridStaff: false,
      showGridTable: false,
    };
  },
  created() {
    this.newBill = Object.assign({}, this.emptyBill);
    const staffs = this.staffs;
    if (!this.isCashier) {
      this.newBill.staff = this.user.ref;
    }
  },
  computed: {
    room() {
      return this.newBill.room;
    },
    staff() {
      if (this.staffSelected) {
        this.newBill.staff = this.staffSelected.ref;
      }
      return this.newBill.staff;
    },
    bill: {
      get() {
        return this.getMap("bill", true);
      },
      set(value) {
        this.$store.state.bill.bill = value;
      },
    },
    emptyBill() {
      return this.getMap("emptyBill", true);
    },
    customers() {
      return this.getArray("customers");
    },
    staffs() {
      return this.getArray("staffs");
    },
    user() {
      return this.getMap("user", true);
    },
    filteredCustomers() {
      let customers = this.customers;
      if(this.search) {
       customers = this.customers.filter(
          customer => customer.name.toLowerCase().indexOf(this.search.toLowerCase()) != -1
          || ( (typeof customer.cardNumber == "string") && customer.cardNumber.toLowerCase().indexOf(this.search.toLowerCase()) != -1)
          );
      }
      const transformedCustomers = [];
      customers.forEach(customer => {
        let cardNumber = typeof customer.cardNumber == "string" ? " (" + customer.cardNumber + ")" : '';
        transformedCustomers.push({
          label: customer.name + cardNumber,
          value: customer.id,
        });
      });
      return transformedCustomers;
    },
    noOptionText() {
      return this.search
        ? this.$gettext("No results found")
        : this.$gettext("Type to search");
    },
  },
  mounted() {
    if (this.step > 0) {
      this.setTable(this.tableSelected);
    }
  },
  watch: {
    room(value) {
      if (value) this.newBill.table = "";
    },
    table(value) {
      if (value) this.newBill.room = "";
    },
    staff(value) {
      //if(value) this.newBill.staff = '';
    },
  },
  methods: {
    pickStaff(staff) {
      this.showGridStaff = this.dialog = false;
      this.newBill.staff = staff.ref;
    },
    pickTable(table) {
      this.showGridTable = this.dialog = false;
      this.setTable(table);
    },
    setTable(table) {
      switch (table.type) {
        case "room": {
          this.newBill.room = table.name;
          //this.room = table;
          this.newBill.table = "";
          break;
        }
        case "table":
        default: {
          this.table = table.name;
          this.newBill.table = table.name;
          this.newBill.room = "";
        }
      }
    },
    showStaffDialog() {
      this.showGridStaff = true;
      this.dialog = true;
    },
    showTableDialog() {
      if (this.$store.state.auth.locations[this.user.location.id].locationTables.length < 1) {
        return false;
      }
      this.showGridTable = true;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    async onSubmit() {
      const formValid = await this.$validator.validate();
      if (formValid) {
        if (this.isChangeOrder) {
          this.bill.cover = this.newBill.cover;
          this.bill.table = this.newBill.table;
          this.bill.room = this.newBill.room;
          await BillService.post(this.bill);
        } else {
          this.newBill.staff = this.staffs.find(
            (staff) => staff.ref == this.newBill.staff
          ).id;
          if (this.newBill.customer) {
            this.newBill.customer = this.newBill.customer.value;
          }
          this.newBill.billItems = [];
          this.$store.dispatch("resetBill");
          this.bill = Object.assign({}, this.newBill);
        }
        this.$router.replace({ name: "order" });
      }
    },
    onSearch(search, loading) {
      this.search = search;
    },
    onFocus() {
      this.showDropdown = this.$refs.customer.mutableOptions.length > 0;
    },
  },
};
</script>

<style scoped>
/* The Modal (background) */
.modal {
  /* display: none;  Hidden by default */
  position: absolute; /* Stay in place */
  z-index: 1; /* Sit on top */
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  width: 100%; /* Full width */
  height: 100vh; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(255, 0, 0); /* Fallback color */
  background-color: rgb(0, 0, 0, 0.5); /* Black w/ opacity */
}
.touch-label-border {
  border-radius: 2px;
  border-color: rgb(35, 23, 202);
  border-width: 3px;
  border-style: solid;
}
</style>  